import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

const HIDDEN_MORE_MENU_OPTION_IDS = new Set(['open', 'move-to-separator', 'remove-from-board', 'remove-separator']);

export const filterCanvasTopBarMoreMenuOptions = (menuOptions: DropdownMenuOption[]) => {
  const filteredOptions = menuOptions.filter((option) => !HIDDEN_MORE_MENU_OPTION_IDS.has(option.id));
  const normalizedOptions: DropdownMenuOption[] = [];

  for (const option of filteredOptions) {
    if (option.type === 'separator') {
      if (normalizedOptions.length === 0) {
        continue;
      }

      if (normalizedOptions[normalizedOptions.length - 1]?.type === 'separator') {
        continue;
      }
    }

    normalizedOptions.push(option);
  }

  if (normalizedOptions[normalizedOptions.length - 1]?.type === 'separator') {
    normalizedOptions.pop();
  }

  return normalizedOptions;
};
